import { Column, GridOption, LoadDataOptions, headerFilter } from "./DataUIType";
import { QueryWrapper } from "@newview/infrastructure";
import moment from "moment"

export class DataGridApi {

  private gridRef?: any;

  constructor(gridRef: any) {
    this.gridRef = gridRef;
  }

  // public init(gridRef: any) {
  //   this.gridRef = gridRef;
  // }

  /**
   * 重置Grid
   */
  public reset() { if (this.gridRef) this.gridRef.reset(); }

  /**
   * 重置查询参数
   */
  public resetSearch() {
    if (this.gridRef) this.gridRef.resetSearch();
  }



  /**
   * 设置参数
   * @param option 
   */
  public setOption(option: GridOption, isReset: boolean = false) {
    if (this.gridRef) {
      this.gridRef.setOption(option, isReset);
    }
  }

  /**  验证是否为null
   * @param obj
  */
  public isNull(obj) {
    if (obj === '' || obj === null || obj === undefined || obj === 'undefined' || obj === 'null') {
      return true
    }
    return false
  }

  /**
   * 解析头部筛选数据，生成Query筛选条件
   * @param filterData 
   * @param queryWrapper 
   */
  public parseHeaderFilter(filterData: headerFilter, qw: QueryWrapper) {
    if (!filterData || typeof filterData !== 'object') return
    // 根据类型对值进行非空校验
    let verify = (config) => {
      const value = config.value
      const type = config.type

      if (type === 'input') {
        return value.trim() !== ""
      } else if (type === 'daterange') {
        return value && !this.isNull(value[0])
      } else if (type === 'select') {
        if (config.multiple === false) {
          // 单选
          return !this.isNull(value)
        } else {
          // 多选
          return value.length > 0
        }
      } else if(type === 'inputnumber'){
        return !this.isNull(value[0])  || !this.isNull(value[1])  
      }

      return false
    }

    for (const key in filterData) {
      if (Object.prototype.hasOwnProperty.call(filterData, key)) {
        const config = filterData[key]
        const value = config.value;
        if (value && verify(config)) {
          switch (config.type) {
            case 'input':
              qw.like(key, value)
              break;
            case 'select':
              if (config.multiple === false) {
                // 单选
                qw.eq(key, value)
              } else {
                qw.in(key, value)
              }
              break;
            case 'daterange':
              let endDate = moment(value[1]).add(1,'day').format('YYYY-MM-DD')
              qw.between(key, value[0],endDate )
              break;
            case 'inputnumber':
              if(!this.isNull(value[0])){
                qw.ge(key,value[0])
              }
              if(!this.isNull(value[1])){
                qw.le(key,value[1])
              }
              break;
          }
        }
      }
    }


  }

  /**
   * 设置当前查询页
   * @param pageIndex 
   */
  public setPageIndex(pageIndex: number) {
    if (this.gridRef) {
      this.gridRef.setPageIndex(pageIndex);
    }
  }

  /**
   * 更新列属性
   * @param key 
   * @param column 
   */
  public updateColumn(key: string, column: Column) { if (this.gridRef) this.gridRef.updateColumn(key, column); }

  /**
   * 加载数据
   * @param readFunction 
   */
  public loadData(readFunction: (options: LoadDataOptions) => void) { if (this.gridRef) this.gridRef.loadData(readFunction); }

  /**
   * 加载数据
   * @param filter 
   * @param orderBy 
   */
  public loadDataByFilter(filter: string = " 1 = 1 ", orderBy: string = " Id ") { if (this.gridRef) this.gridRef.loadDataByFilter(filter, orderBy); }

  /**
   * 加载数据
   * @param queryWrapper 
   */
  public loadDataByQuery(queryWrapper: QueryWrapper) { if (this.gridRef) this.gridRef.loadDataByQuery(queryWrapper); }

  /**
   * 刷新
   */
  public refresh() { if (this.gridRef) this.gridRef.refresh(); }

  /**
   * 设置全局值
   * @param key key 
   * @param value "$datetime" | "$time" | "$guid" | any
   * @param isOnlyAddSetValue 是否只在添加时赋值
   */
  public setGloablValue(key, value: "$datetime" | "$time" | "$guid" | any, isOnlyAddSetValue: boolean = false) { if (this.gridRef) this.gridRef.setGloablValue(key, value, isOnlyAddSetValue); }

  /**
   * 获取选中的数据
   * @param key 
   */
  public getCheckedDatas(key?: string) { if (this.gridRef) return this.gridRef.getCheckedDatas(key); else[]; }

  /**
   * 设置Check选择
   * @param id 
   * @param checked 
   * @param key 
   */
  public setChecked(id, checked: boolean, key?: string) {
    if (this.gridRef) this.gridRef.setChecked(id, checked, key);
  }

  /**
   * 设置值
   * @param row 
   * @param key 
   * @param value 
   */
  public setDataValue(row, key, value) { if (this.gridRef) this.gridRef.setDataValue(row, key, value); }

  /**
   * 获取所有值
   */
  public getAllData() { if (this.gridRef) return this.gridRef.datas; else return []; }

  /**
   * 获取编辑后的值
   */
  public getEditData() {
    if (this.gridRef) {
      const saveDatas: any[] = JSON.parse(JSON.stringify(this.gridRef.editDatas));
      for (const item of saveDatas) {
        this.intoGloablValue(item);
        if (item.Id <= 0) {
          item.Id = 0
        }
      }

      return saveDatas;
    } else return [];
  }

  /**
   * 添加行数据
   * @param data 
   */
  public addRow(data) {
    if (this.gridRef) {
      this.gridRef.addRowData(data);
    }
  }

  /**
   * 关闭编辑模式
   */
  public closeEditMode() { if (this.gridRef) return this.gridRef.closeEditMode(); }

  /**
   * 打开编辑模式
   */
  public openEditMode() { if (this.gridRef) return this.gridRef.openEditMode(); }

  /**
   * 选择行
   * @param rowId 行Id
   * @returns 
   */
  public selectRow(rowId) { if (this.gridRef) return this.gridRef.selectRow(rowId); }

  /**
   * 获取所有父级节点
   * @param row 
   * @returns 
   */
  public getParentRows(row): any[] {
    if (this.gridRef) {
      return this.gridRef.getParentRows(row);
    }
    else {
      return [];
    }
  }

  /**
   * 获取选择的行
   * @returns 
   */
  public getSelectRow() { if (this.gridRef) return this.gridRef.getSelectRow(); else return undefined; }

  public resize() { if (this.gridRef) return this.gridRef.resize(); }

  /** 设置全局点击事件 */
  public setGloablClick(click: Function) {
    if (this.gridRef) return this.gridRef.setGloablClick(click);
  }

  public intoGloablValue(row) {
    if (this.gridRef) return this.gridRef.intoGloablValue(row);
  }

  public setRowEdit(row, isEdit) {
    if (this.gridRef) return this.gridRef.setRowEdit(row, isEdit);
  }

  public doDefaultAdd() {
    if (this.gridRef) return this.gridRef.doDefaultAdd();
  }
  public setDatas(data) {
    if (this.gridRef) return this.gridRef.setDatas(data);
  }

  /**
   * 删除数据
   * @param data 
   * @returns 
   */
  public delete(data) {
    if (this.gridRef) return this.gridRef.delete(data);
  }

  /**
   * 得到查询条件
   */
  public getParams() { if (this.gridRef) return this.gridRef.getParams(); }

  /**
   * 设置Cloumn
   * @param columns
   * @param isReset
   */
  public setCloumn(columns: [], isReset: boolean = false) {
    if (this.gridRef) {
      this.gridRef.setCloumn(columns, isReset);
    }
  }
}

// export default new DataGrid1();

